/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Box, Modal, Grid, Tooltip, Divider, Button } from '@mui/material';
import { get, isEmpty } from 'lodash';
import { Rnd } from 'react-rnd';
import LoadingButton from '@mui/lab/LoadingButton';

import FeedType from './feed-type';
import FeedTable from './feed-table';
import Parameters from './parameters';
import Saturation from './saturation';
import { populateDataintoTable } from './FeedUploadFile';

import * as validation from '../../shared/validation';
import Notification from '../../shared/notification-modal';
import columnDefs from '../../column-defs';
import { closeIconBlack, download_feed } from '../../shared/assets/images';
import jsLogger from '../../logger';

import {
  decimalFormatter,
  fahrenheitToTemperature,
  getSumValuesOfIon,
  getMassAndCharge,
  getCalculatedRows,
  getTotal,
  getSumValuesForProp,
  isObjectEmpty,
  canCellBeEditable,
} from '../../shared/helper';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { getBorderColor, getMail, encrypt_data, decrypt_data } from '../../shared/utils';
import { postFeedInput, defaultUnits, downloadFile, deleteWinAndProjectFile } from '../../shared/api/url-helper';
import {
  clonedWaterCompData,
  anionsProp,
  cationsProp,
  defaultUnitValues,
  saturationDetails,
  defaultModalOptions,
  unitsForPressure_atm,
  unitsForFlow_m3persec,
  waterSource
} from '../../shared/constantVariable';
import './feed-analysis.scss';
import { convertUnitValues_flow, convertUnitValues_pressure } from '../../shared/conversion-helper/unitConversion';

let tdsUpdated = false;
const flowData = {};
const pressureData = {};
const localPressure_atm = {};
const Feed = (props) => {
  const { setVisibleFeed, dbTransactionDetails, feedItem, handleFeedItem, visibleFeed, disabledStripperAndExplorerTab, text, translateObject, setokbuttonFormAutoSave } = props;
  const isWaterAnalysis = feedItem.type === 'customnode_Wateranalysis';
  const properties = [
    { hdata: 'Ion', tag: 'Ion', disabled: true, datatype: 'text' },
    { hdata: 'mg/l', tag: 'MgL', disabled: null, datatype: 'number' },
    { hdata: 'meq/l', tag: 'Meq', disabled: null, datatype: 'number' },
    { hdata: 'ppm as CaCO3', tag: 'ppmAsCaCO3', disabled: null, datatype: 'number' }
  ];
  const csvExcludeColumns = ['Total Anions', 'Total Cations', 'Carbon Dioxide (CO2)', 'Bicarbonate (HCO3)', 'Carbonate (CO3)'];
  const defaultCol = ['Total Anions', 'Total Cations'];
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [waterTypeObj, setWaterTypeObj] = useState({
    waterSource: 4, // changed the default water type
    waterType: 1,
  });
  const [gridApi, setGridApi] = useState(null);
  const [nullParam, setNullParam] = useState(false);
  const [clonedWaterComp] = useState(clonedWaterCompData);
  const { cations, anions } = clonedWaterComp[waterTypeObj.waterType];
  const [cationsData, setCations] = useState(cations);
  const [anionsData, setAnions] = useState(anions);
  const [rowData, setRowData] = useState(
    getCalculatedRows(cationsData, anionsData)
  );

  // by Abhishek ->
  const [cationsDataTemp, setCationsTemp] = useState(cations);
  const [anionsDataTemp, setAnionsTemp] = useState(anions);

  const [inputMode, setInputType] = useState('ph_alk');
  const [params, setParams] = useState({
    malk: 120.0,
    tds: '',
    ph: 7.0,
    temperatureDc: 25.0,
    temperatureFh: 77.0,
    sdi: 4.0,
    toc: 0.0,
    feedFlow: 0.0,
    pressure: 1.97  // default value in atm 1.97385
  });
  const [isBalanceClicked, setIsBalanceClicked] = useState(false);
  const [disableBalance, setDisableBalance] = useState(true);
  const [disableOkButton, setDisableOkButton] = useState(true);
  const [totalCompObj, setTotalCompObj] = useState({
    tot_cation_meql: 0,
    tot_cation_ppmcaco3: 0,
    tot_anion_meql: 0,
    tot_anion_ppmcaco3: 0,
  });
  const [balanceBtnLoading, setBalanceBtnLoading] = useState(false);
  const [prev, setPrevious] = useState(params.tds);
  const [, setGridColumnApi] = useState(null);
  const [downloading, setDownloading] = useState(false);

  const [argoTemplate, setArgoTemplate] = useState(false);
  const [, setPrevParamsChanged] = useState(false);
  const [unitObj, setUnitObj] = useState(defaultUnitValues);
  const [units, setUnits] = useState(defaultUnitValues);
  const [balanceObj, setBalanceObj] = useState({
    cb_cation: 'Na+',
    cb_anion: 'Cl-',
  });
  const [compositionType, setCompositionType] = useState({
    composition: 'feed'
  });
  const [isShowNF_Feed, setisShowNF_Feed] = useState(false);
  const [chargeBalanceIon, setChargeBalanceIon] = useState(false);
  const [saturation, setSaturation] = useState(saturationDetails);
  const [molalDict, setMolalDict] = useState({});
  const [hardness_val, setHardness] = useState(0.0);
  const [ionicStrength, setIonicStrength] = useState(0.0);
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);

  let convertedPressureValue;
  // multiple dict. report PDF
  const [fileUploadStatus, setFileUploadStatus] = useState(''); // file upload status
  const [pdfDdMenuItem, setpdfDdMenuItem] = useState([]); // pdfDropdownMenuItem
  const [pdfdropdown, setpdfdropdown] = useState('');
  const handleChangePdfRes = (event) => {
    setpdfdropdown(event.target.value);
    populateDataintoTable(event.target.value);
  };
  // state de-structure
  // const { temperatureDc, temperatureFh, tds, sdi, ph, malk, toc, feedFlow } = params;

  const temperatureDc = parseFloat(params.temperatureDc);
  const temperatureFh = parseFloat(params.temperatureFh);
  const tds = parseFloat(params.tds);
  const sdi = parseFloat(params.sdi);
  const ph = parseFloat(params.ph);
  const malk = parseFloat(params.malk);
  const toc = parseFloat(params.toc);
  const feedFlow = parseFloat(params.feedFlow);

  // validation layer start
  const [touchedFields, setTouchedFields] = useState({});
  const { schema } = columnDefs.parameters.forms;
  if (inputMode === 'ph_alk') {
    schema.required = Array.from(new Set([...schema.required, 'malk']));
    schema.errorMessage.required.malk = 'Total Alkalinity is required';
  } else {
    schema.required = schema.required.filter((val) => val !== 'malk');
    delete schema.errorMessage.required.malk;
  }
  const errors = validation.validation({
    schema,
    data: {
      temperatureFh,
      temperatureDc,
      tds,
      sdi,
      ph,
      malk,
      toc,
      feedFlow,
    },
  });

  const handleBlur = (e) => {
    const { name, value, id } = e.target;
    if (value === '') {
      e.target.style.border = '2px solid #e42b0a';
      e.target.style.borderRadius = '22px';
      setNullParam(true);
    } else {
      e.target.style.border = '0.5px solid #c7dbe88a';
      e.target.style.borderRadius = '22px';
      setNullParam(false);
    }
    setPrevious(localStorage.getItem('tds'));
    const previousParams = JSON.parse(localStorage.getItem('params'));
    if(+previousParams[name] !== +value){
      jsLogger.info(`Feed Paramter change # ${name} : ${previousParams[name]} -> ${value}`);
    }
    setTouchedFields({
      ...touchedFields,
      [name || id]: true,
    });
    localStorage.setItem(
      'params',
      JSON.stringify({ ...previousParams, [name]: value })
    );
    if (name === 'tds' && value >= 0) {
      localStorage.setItem(name, value);
    }
    if (name === 'malk' && params.ph < 4.5) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Alkalinity is 0 when ph is below or equal to 4.5'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions),
      });
      setParams({ ...params, malk: 0.0 });
    } else {
      setParams({ ...params, [name]: value ? Number(value) : '' });
    }
    if ((name === 'sdi' && Number(value) !== Number(previousParams.sdi)) || (name === 'toc' && Number(value) !== Number(previousParams.toc)))
      setDisableOkButton(false);
    if (
      (name === 'malk' && Number(value) !== Number(previousParams.malk)) ||
      (name === 'ph' && Number(value) !== Number(previousParams.ph)) ||
      (name === 'temperatureFh' &&
        Number(value) !== Number(previousParams.temperatureFh)) ||
      (name === 'temperatureDc' &&
        Number(value) !== Number(previousParams.temperatureDc)) ||
      (name === 'tds' &&
        Number(value) !== Number(previousParams.tds))
    ) {
      setDisableOkButton(true); //  by Abhishek on 10-7
      setDisableBalance(false);
      setPrevParamsChanged(true);
    }
    if ((Number(value) === 0 || value === '') && name === 'feedFlow');
    else {
      setParams({ ...params, feedFlow: Number(value) });
    }
    if (name === 'ph' && value < 4.5) {
      setParams({ ...params, malk: 0.0 });
    }
    else if (name === 'ph' && (value < 0 || value > 14)) {
      let clampedValue;
      if (value > 14) {
        clampedValue = 14;
      } else if (value < 0) {
        clampedValue = 0;
      } else {
        clampedValue = value;
      }
      setParams({ ...params, [name]: clampedValue });
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: 'pH must be in the range 0-14',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions),
      });
    }
    else {
      setParams({
        ...params,
        [name]: value ? parseFloat(decimalFormatter(value, 2)) : '',
      });
    }
  };

  const validationDiv = (field) =>
    validation.errorDiv(errors, touchedFields, field);
  // validation layer end
  // refresh grid
  const refreshGrid = () => {
    const refreshParams = {
      force: true,
      suppressFlash: true,
    };
    gridApi.refreshCells(refreshParams);
  };

  const clearRowData = () => {
    const filterdData = rowData.filter((obj) => {
      return !defaultCol.find((val) => val === obj.Ion);
    });
    const dummyCat = [];
    const dummyAn = [];
    filterdData.map((obj) => {
      const { ionType } = getMassAndCharge(obj);
      if (ionType === 'cations') {
        dummyCat.push({
          ...obj,
          MgL: 0,
          Meq: 0,
          ppmAsCaCO3: 0,
          ionType,
        });
      } else {
        dummyAn.push({
          ...obj,
          MgL: 0,
          Meq: 0,
          ppmAsCaCO3: 0,
          ionType,
        });
      }
    });
    const { updatedCat, updatedAn } = getSumValuesOfIon(dummyCat, dummyAn);
    setAnions(updatedAn);
    setCations(updatedCat);
    setAnionsTemp(updatedAn);
    setCationsTemp(updatedCat);
    setRowData(getCalculatedRows(updatedCat, updatedAn));
  };

  const updateFeedDataFromLocalStorage = (localObj) => {
    if (isObjectEmpty(localObj)) {
      const { localParams = {}, localSaturation = {} } = localObj;
      if (isObjectEmpty(localParams)) {
        setParams({ ...params, ...localParams, 'pressure': convertedPressureValue }); // eslint-disable-next-line
        localParams.pressure = convertedPressureValue ? convertedPressureValue : localParams.pressure;
        localStorage.setItem('params', JSON.stringify(localParams));
        localStorage.setItem('tds', JSON.stringify(localParams.tds)); // by Abhishek: storing tds value when user open saved file
      }
      if (isObjectEmpty(localSaturation)) setSaturation({ ...saturation, ...localSaturation });
      setBalanceObj({ ...balanceObj, ...localObj.balanceObj });
      setInputType(localObj.inputMode || inputMode);
      setWaterTypeObj({ ...localObj.waterTypeObj });
      setChargeBalanceIon(get(localObj, 'chargeBalanceIon', false));
      const arr = localObj['grid-data'];
      if (arr && arr.length) {
        const dummyCat = [];
        const dummyAn = [];
        const filterdData = arr.filter((obj) => {
          return !defaultCol.find((val) => val === obj.Ion);
        });
        filterdData.map((obj) => {
          const { ionType } = getMassAndCharge(obj);
          if (ionType === 'cations') {
            dummyCat.push({
              ...obj,
              ionType,
            });
          } else {
            dummyAn.push({
              ...obj,
              ionType,
            });
          }
        });
        setAnions(dummyAn);
        setCations(dummyCat);
        setAnionsTemp(dummyAn);
        setCationsTemp(dummyCat);
        setRowData(arr);
      }
    } else {
      clearRowData();
    }
  };

  const fetchUnits = async () => {
    const destroyParam = localStorage.getItem('system-units');
    const parsedData = JSON.parse(destroyParam);
    if (isObjectEmpty(parsedData)) {
      setUnitObj(parsedData);
      const { temp, pressure, flow } = parsedData;
      setUnits({ ...units, ...parsedData });
      // ########## Temp #############
      if (temp === '°F') {
        setParams({
          ...params,
          temperatureFh: parseFloat(decimalFormatter(temperatureDc * 1.8 + 32, 2)),
        });
      } else {
        setParams({
          ...params,
          temperatureDc: parseFloat(decimalFormatter((temperatureFh - 32) * (5 / 9), 2)),
        });
      }
      // ############ Flow ########### parseFloat(decimalFormatter(convertUnitValues(localData.localParams.feedFlow, flow)))
      if (flow) {
        const previous_flow_unit = localStorage.getItem('previous_flow_unit'); // localData.localParams.feedFlow
        if (previous_flow_unit) {
          setParams({
            ...params,
            feedFlow: parseFloat(convertUnitValues_flow(flowData[feedItem.id], previous_flow_unit, flow)),
          });
          flowData[feedItem.id] = parseFloat(convertUnitValues_flow(flowData[feedItem.id], previous_flow_unit, flow));
        }
        localStorage.setItem('previous_flow_unit', flow);

      }
      // ############ Pressure ###########
      if (pressure !== null) {
        const previous_pressure_unit = localStorage.getItem('previous_pressure_unit');
        // GB-2696- if user enters '0' value in feed pressure then values are not getting stored. start
        if (localPressure_atm[feedItem.id] !== undefined) {
          convertedPressureValue = convertUnitValues_pressure(localPressure_atm[feedItem.id], 'atm', pressure);
        } else if (Number(localPressure_atm[feedItem.id]) === 0) {
          convertedPressureValue = convertUnitValues_pressure(localPressure_atm[feedItem.id], 'atm', pressure);
        }
        // GB-2696- if user enters '0' value in feed pressure then values are not getting stored. start
        else {
          const defaultPrs = pressureData[feedItem.id] ? pressureData[feedItem.id] : '1.97385';
          if (defaultPrs === '1.97385' && pressure !== 'atm') {
            convertedPressureValue = convertUnitValues_pressure(defaultPrs, 'atm', pressure);
          } else if (defaultPrs === '1.97385' && previous_pressure_unit !== 'atm') {
            convertedPressureValue = convertUnitValues_pressure(defaultPrs, 'atm', pressure);
          } else { // eslint-disable-next-line
            convertedPressureValue = convertUnitValues_pressure(defaultPrs, previous_pressure_unit ? previous_pressure_unit : 'atm', pressure);
          }
        }
        setParams({
          ...params,
          pressure: parseFloat(convertedPressureValue),
        });
        pressureData[feedItem.id] = parseFloat(convertedPressureValue);
        localPressure_atm[feedItem.id] = convertUnitValues_pressure(pressureData[feedItem.id], pressure, 'atm');

      }

    } else {
      const parsedFeedData = get(JSON.parse(localStorage.getItem('form')), `feed.${feedItem.id}`, {});
      if (isObjectEmpty(parsedFeedData)) {
        convertedPressureValue = parsedFeedData.localParams.pressure;
      }
      const userMailId = await getMail();
      const getParams = { method: 'get', user_id: userMailId };
      defaultUnits(getParams)
        .then((res) => {
          const { data } = res;
          if (data.data.length !== 0) {
            setUnitObj(data.data[0]);
            const responseObj = data.data[0];
            const { temp } = responseObj;
            setUnits({ ...units, ...responseObj });
            if (temp === '°F') {
              setParams({
                ...params,
                temperatureFh: parseFloat(decimalFormatter(temperatureDc * 1.8 + 32, 2)),
              });
            } else {
              setParams({
                ...params,
                temperatureDc: parseFloat(decimalFormatter((temperatureFh - 32) * (5 / 9), 2)),
              });
            }
          } else {
            setUnits({ ...units, ...defaultUnitValues });
          }
        })
        .catch(() => {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Error',
            message: 'Failed to fetch default units',
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions),
            type: 'error'
          });
        });
    }

  };

  const getRowDataFromLocalStorage = (localObj, feedItem) => {
    if (isObjectEmpty(localObj)) {
      updateFeedDataFromLocalStorage(localObj, feedItem);
    } else {
      clearRowData();
    }
  };

  // use effect start
  useEffect(() => {
    return () => {
      localStorage.removeItem('params');
      localStorage.removeItem('focusedColumn');
      handleFeedItem();
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(feedItem)) {
      localStorage.setItem('params', JSON.stringify(params));
      const parsedFeedData = get(JSON.parse(localStorage.getItem('form')), `feed.${feedItem.id}`, {});
      const feed_dict_data = get(JSON.parse(localStorage.getItem('feed-dict')), `feed.${feedItem.id}`, {});
      setMolalDict(feed_dict_data.molal_dict);
      // GB-2882 added by chandrashekhar when user change the value in feed form
      if (Object.keys(feed_dict_data).length > 0 && feed_dict_data.prop_dict) {
        pressureData[feedItem.id] = feed_dict_data.prop_dict.press;
      }
      setCompositionType({ ...compositionType, composition: feed_dict_data.isFeedComposition || 'feed' });
      fetchUnits(parsedFeedData);
      getRowDataFromLocalStorage(parsedFeedData, feedItem);
      setisShowNF_Feed(parsedFeedData.isShowNF_Feed);
    }
  }, [feedItem]);

  useEffect(() => {
    if (
      prev &&
      Number(prev) !== 0 &&
      params.tds !== Number(prev) &&
      params.tds >= 0
    ) {
      const filterdData = rowData.filter((obj) => {
        return !defaultCol.find((val) => val === obj.Ion);
      });
      const dummyCat = [];
      const dummyAn = [];
      filterdData.map((obj) => {
        const mgl = (obj.MgL * params.tds) / prev;
        const fixed = Number(mgl).toFixed(3);
        const { mass, charge, ionType } = getMassAndCharge(obj);
        const abs = Math.abs(charge);
        if (ionType === 'cations') {
          dummyCat.push({
            ...obj,
            MgL: mgl,
            ionType,
            Meq: abs > 0 ? fixed / (mass / abs) : fixed / mass,
            ppmAsCaCO3:
              abs > 0
                ? (fixed * 50.0435) / (mass / abs)
                : (fixed * 50.0435) / mass,
          });
        } else {
          dummyAn.push({
            ...obj,
            MgL: mgl,
            ionType,
            Meq: abs > 0 ? fixed / (mass / abs) : fixed / mass,
            ppmAsCaCO3:
              abs > 0
                ? (fixed * 50.0435) / (mass / abs)
                : (fixed * 50.0435) / mass,
          });
        }
      });
      const { updatedCat, updatedAn } = getSumValuesOfIon(dummyCat, dummyAn);
      setAnions(updatedAn);
      setCations(updatedCat);
      setAnionsTemp(updatedAn);
      setCationsTemp(updatedCat);
      setRowData(getCalculatedRows(updatedCat, updatedAn));
    }
  }, [prev]);
  // use effect end

  const checkDisable = () => {
    const payload = {};

    const totval = rowData.map((item) => { return item.Meq; });
    let sum_cation = 0;
    let sum_anion = 0;

    totval.forEach((item, index) => {
      if (index === 9)  // index 9 = sum of Cation (in meq/l)
        sum_cation = item;
      else if (index === 22) // index 22  = sum of aninon (in meq/l)
        sum_anion = item;
    });

    if (Number(sum_cation.toFixed(4)) !== Number(sum_anion.toFixed(4))) {
      setDisableBalance(false);
      setDisableOkButton(true);
    } else {
      setDisableBalance(true);
      setDisableOkButton(false);
    }
    rowData.map((rowNode) => {
      if (defaultCol.includes(rowNode.Ion)) {
        payload[rowNode.Ion] = decimalFormatter(rowNode.Meq, 4);
      }
    });
  };
  // get JSON formatted table values idher
  const getDetailGridInfo = (array = false) => {
    const allRow = [];
    const payload = {};
    // getting the stored seprate varible for the payload
    // if it not there it means user didn't edited any cell then take rowData for the calculation
    // const feedData = JSON.parse(localStorage.getItem('feedRows')) || rowData;
    // feedData.map((rowNode) => {   // -> this line modified 20-9 by abhi -> uncomment this line when u need pass eaxact user input
    rowData.map((rowNode) => {  // -> this line too, commnet it to remove user input accuracy and send round off table value
      if (!defaultCol.includes(rowNode.Ion)) {
        allRow.push(rowNode);
        payload[rowNode.IonCode] = Number(
          rowNode.MgL
        );
      }
    });
    return array ? allRow : payload;
  };

  useEffect(() => {
    checkDisable();
    const payload = getDetailGridInfo();
    if(getTotal(payload)===0){
      setDisableOkButton(true);
    };
  }, [rowData]);

  // setting the grid api for future access
  const onGridReady = (gridParams) => {
    setGridApi(gridParams.api);
    setGridColumnApi(gridParams.columnApi);
  };
  // modify values based on water type while hover
  const renderValues = async (obj) => {
    const { id } = obj;
    const data = clonedWaterComp[id] || {};
    const { updatedCat, updatedAn } = getSumValuesOfIon(
      data.cations,
      data.anions
    );
    setAnions(updatedAn);
    setCations(updatedCat);
    setAnionsTemp(updatedAn);
    setCationsTemp(updatedCat);
    setRowData(getCalculatedRows(updatedCat, updatedAn));
  };

  const handleChangeUnit = async (type, value) => {
    setUnits({ ...units, temp: type });
    const userMailId = await getMail();
    const payload = {
      method: 'put',
      temp: type,
      isTemp: true,
      user_id: userMailId,
    };
    if (type === '°F') {
      setParams({
        ...params,
        temperatureFh: parseFloat(decimalFormatter(value * 1.8 + 32, 2)),
      });
    } else {
      setParams({
        ...params,
        temperatureDc: parseFloat(decimalFormatter((value - 32) * (5 / 9), 2)),
      });
    }
    defaultUnits(payload).then(() => {
      const localUnits = JSON.parse(localStorage.getItem('system-units'));
      if (isObjectEmpty(localUnits)) {
        const updateUnits = { ...localUnits, temp: type };
        localStorage.setItem('system-units', JSON.stringify(updateUnits));
      }
    });
  };

  // clear paramans : added : SDI, TOC to default value by Abhishek on 3-9-25
  const clearParams = () => {
    setParams({ ...params, tds: 0, malk: 120.0, ph: 7.0, temperatureDc: 25, temperatureFh: 77, sdi: 4.0, toc: 0.0 });
    setSaturation(saturationDetails);
    localStorage.removeItem('tds');
  };

  const handleChangeWaterType = (event) => {
    setpdfDdMenuItem([]);  // remove pdf Dropdown
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    const { name, value } = event.target;
    jsLogger.info(`Feed ${name} type changes to ${value}`);
    if (name === 'waterSource') {
      setWaterTypeObj({ ...waterTypeObj, [name]: value });
      setDisableOkButton(true);  // added by Abhishek on 12-12-24 for onChange of 'Select Water Source' -> enable 'OK' btn
    } else {
      localStorage.removeItem('feedRows'); // deleting this when water type changes
      setWaterTypeObj({ ...waterTypeObj, [name]: value });
      renderValues({ id: value });
      setIsBalanceClicked(false);
      setDisableBalance(false);
      setDisableOkButton(true); // added by kranthi to disable ok button on water type change
      clearParams();
      tdsUpdated = false;
      disabledStripperAndExplorerTab();
    }
  };
  // update cell values and get calculated based on formulae
  const handleAfterEdit = (e) => {
    if (Number(e.target.value) < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: 'Feed Compositions must be a positive number',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    else {
      const current = e.target.id;
      const flag = current.indexOf('_', 9);
      const row = Number(current.substring(9, flag)) - 1;
      const col = Number(current.substring(flag + 1)) - 1;
      const field = properties[col].tag;
      const data = rowData[row];
      data[field] = Number(e.target.value);
      const {
        tot_anion_meql,
        tot_anion_ppmcaco3,
      } = totalCompObj;
      const { MgL, Meq, ppmAsCaCO3 } = data;
      const { mass, charge, ionType } = getMassAndCharge(data);
      const abs = Math.abs(charge);

      jsLogger.info(`Feed form table : ${data.Ion} changes to ${data[field]} ${field}`);

      if (field === 'MgL' && data.Ion !== 'CO2') {
        const fixed = Number(MgL.toFixed(3));
        data.Meq = abs > 0 ? fixed / (mass / abs) : fixed / mass;
        data.ppmAsCaCO3 =
          abs > 0 ? (fixed * 50.0435) / (mass / abs) : (fixed * 50.0435) / mass;

      } else if (field === 'Meq') {
        const fixed = Number(Meq.toFixed(4));
        data.MgL = abs > 0 ? fixed * (mass / abs) : fixed * mass;
        data.ppmAsCaCO3 = fixed * 50.0435;

      } else if (field === 'ppmAsCaCO3') {
        const fixed = Number(ppmAsCaCO3.toFixed(2));
        data.MgL =
          abs > 0 ? (fixed * (mass / abs)) / 50.0435 : (fixed * mass) / 50.0435;
        data.Meq = fixed / 50.0435;
      }

      // by Abhishek -> sending exact user input to payload
      // storing the user input value to a seprate variable
      // for the 1st time cell edit 'feedRows' will not be available in localstorage, so use empty array []
      const tempfeedData = JSON.parse(localStorage.getItem('feedRows')) || [];
      const localCationsDataTemp = tempfeedData.slice(0, 9); // cation array
      const localAnionsDataTemp = tempfeedData.slice(10, 22); // anion array

      // below if-else condition will capture the user changed and keep updating the seprate variable
      if (ionType === 'cations') {
        if (tempfeedData.length === 0) {  //  this if condition will execute for the 1st cell edit []
          if (cationsDataTemp[row].IonCode === data.IonCode) {
            cationsDataTemp[row].MgL = Number(data.MgL);
            cationsDataTemp[row].Meq = Number(data.Meq);
            cationsDataTemp[row].ppmAsCaCO3 = Number(data.ppmAsCaCO3);
          }
        }
        else {// eslint-disable-next-line
          if (localCationsDataTemp[row].IonCode === data.IonCode) { // this else condition will execute after 2nd cell edit
            localCationsDataTemp[row].MgL = Number(data.MgL);
            localCationsDataTemp[row].Meq = Number(data.Meq);
            localCationsDataTemp[row].ppmAsCaCO3 = Number(data.ppmAsCaCO3);
          }
        }
      }
      else if (ionType === 'anions') {
        if (tempfeedData.length === 0) {
          if (anionsDataTemp[row - 10].IonCode === data.IonCode) { //  this if condition will execute for the 1st cell edit []
            anionsDataTemp[row - 10].MgL = Number(data.MgL);
            anionsDataTemp[row - 10].Meq = Number(data.Meq);
            anionsDataTemp[row - 10].ppmAsCaCO3 = Number(data.ppmAsCaCO3);
          }
        }
        else {// eslint-disable-next-line
          if (localAnionsDataTemp[row - 10].IonCode === data.IonCode) { // this else condition will execute after 2nd cell edit
            localAnionsDataTemp[row - 10].MgL = Number(data.MgL);
            localAnionsDataTemp[row - 10].Meq = Number(data.Meq);
            localAnionsDataTemp[row - 10].ppmAsCaCO3 = Number(data.ppmAsCaCO3);
          }
        }
      }
      let rowsTemp;
      if (tempfeedData.length === 0) //  for the 1st time edit cell
        rowsTemp = getCalculatedRows(cationsDataTemp, anionsDataTemp);
      else // to capture all the edited cell
        rowsTemp = getCalculatedRows(localCationsDataTemp, localAnionsDataTemp);
      // storing the changed value into separate veriable
      localStorage.setItem('feedRows', JSON.stringify(rowsTemp));
      // by Abhishek -> end here

      if (ionType === 'cations') {
        if (cationsData[row].IonCode === data.IonCode) {
          cationsData[row].MgL = Number(data.MgL.toFixed(3));
          cationsData[row].Meq = Number(data.Meq.toFixed(4));
          cationsData[row].ppmAsCaCO3 = Number(data.ppmAsCaCO3.toFixed(2));
        }
      } else if (ionType === 'anions') {
        if (anionsData[row - 10].IonCode === data.IonCode) {
          anionsData[row - 10].MgL = Number(data.MgL.toFixed(3));
          anionsData[row - 10].Meq = Number(data.Meq.toFixed(4));
          anionsData[row - 10].ppmAsCaCO3 = Number(data.ppmAsCaCO3.toFixed(2));
        }
      }

      let rows = getCalculatedRows(cationsData, anionsData);
      if (isBalanceClicked) {

        // convert to number here and used the variable in the obj down
        const temp_mgl_cation = Number(getSumValuesForProp(cationsData, 'MgL'));
        const temp_mgl_anion =  Number(getSumValuesForProp(anionsData, 'MgL'));

        rows = [
          ...cationsData,
          {
            Ion: 'Total Cations',
            MgL: temp_mgl_cation.toFixed(3), //  removed 3 decimal place for mg/l as we have added it in helper.js
            Meq: Number(getSumValuesForProp(cationsData, 'Meq')),
            ppmAsCaCO3: Number(getSumValuesForProp(cationsData, 'ppmAsCaCO3')),
          },
          ...anionsData,
          {
            Ion: 'Total Anions',
            MgL: temp_mgl_anion.toFixed(3),  //  removed 3 decimal place for mg/l as we have added it in helper.js
            Meq: Number(tot_anion_meql.toFixed(4)),
            ppmAsCaCO3: Number(tot_anion_ppmcaco3.toFixed(2)),
          },
        ];
      };
      setRowData(rows);
      setDisableBalance(false);
      setDisableOkButton(true);
      disabledStripperAndExplorerTab();
    }
  };

  const handleChangeParams = (event) => {
    const { value, name } = event.target;
    setParams({ ...params, [name]: value ? Number(value) : '' });
    if (name === 'pressure') {
      pressureData[feedItem.id] = parseFloat(value);
      setDisableOkButton(false);
    } else if (name === 'tds') {
      tdsUpdated = true;
    }
    disabledStripperAndExplorerTab();
  };

  // export table data's as CSV file
  const onBtnExport = () => {
    const { temp } = units;
    const { temperatureFh, temperatureDc } = params;
    const tempKey = temp === '°F' ? 'F' : 'C';
    const excelParams = getDetailGridInfo(true);
    const excelArr = [
      ['Feed Water Composition'],
      ['Ion', 'mg/l', 'meq/l', 'PPM as CaCO3'],
    ];
    excelParams.map((obj) => {
      if (!csvExcludeColumns.includes(obj.Ion)) {
        excelArr.push([obj.Ion, obj.MgL.toString(), obj.Meq.toString(), obj.ppmAsCaCO3.toString()]);
        return [obj.Ion, obj.MgL, obj.Meq, obj.ppmAsCaCO3];
      }
    });
    excelArr.push(
      ['Alkalinity', params.malk],
      [`Temperature (deg ${tempKey})`, temp === '°F' ? temperatureFh : temperatureDc],
      ['pH', params.ph]
    );
    const load = {
      fileName: 'feed Water Composition',
      csvData: excelArr
    };
    setDownloading(true);
    downloadFile(load).then((res) => {
      const filename = `feed Water Composition-${text}.csv`; // your desired filename
      const bb = JSON.parse(res.config.data);
      // Added by Akhil on 19th June to append json data into newly created csv file on the fly.
      const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
        bb.csvData.join('\n')
      )}`;
      const link = document.createElement('a');
      link.href = jsonString;
      link.download = filename; // creating file name
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setDownloading(false);
      // setTimeout(() => deleteFile({ fileName: res.data.fileName }), 3000); { '0': `${fNaam}.json` } // commented by Abhi on 20-5-25: to pass the full path of the .csv file to delete that after getting downlaod
      setTimeout(() => deleteWinAndProjectFile('', '', { '0': `winflows_file_management/feed_input_files/${res.data.url.split('/')[5].trim()}`}), 3000);
    }).catch(() => {
      setDownloading(false);
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Error',
        message: 'failed to download the file',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions),
        type: 'error'
      });
    });
  };

  const handleChangeChargeBalance = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    const { name, value } = e.target;
    jsLogger.info(`Feed Select Ion for Charge Balance : ${name} change to ${value}`);
    setBalanceObj({ ...balanceObj, [name]: value });
    disabledStripperAndExplorerTab();
  };
  const handleChangeWaterComposition = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    const { name, value } = e.target;
    jsLogger.info(`Feed Select Ion for Charge Balance : ${name} change to ${value}`);
    setCompositionType({ ...compositionType, [name]: value });
    disabledStripperAndExplorerTab();
  };

  const handleChangeArgoTemplate = (e) => {
    setArgoTemplate(e.target.checked);
  };

  const calculateBalance = () => {
    if (Object.keys(errors).length) {
      const touchFieds = {};
      Object.keys(errors).forEach((error) => {
        touchFieds[error] = true;
      });
      setTouchedFields({ ...touchFieds });
    } else {
      const payload = getDetailGridInfo();
      if (getTotal(payload) <= 0) {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          message: 'Please enter water composition',
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions),
        });
      } else if (
        inputMode === 'co2_hco3' &&
        (payload['HCO3-'] <= 0 || payload.CO2 <= 0)
      ) {
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          message: 'CO2, HCO3- cannot be zero',
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
      } else {
        const obj = {
          is_nf_module: isShowNF_Feed,
          ion_ppm_dict: { ...payload },
          final_table_dict: dbTransactionDetails,
          prop_dict: {
            malk: parseFloat(params.malk),
            ph: parseFloat(params.ph),
            toc: parseFloat(params.toc),
            temp:
              units.temp === '°F'
                ? parseFloat(fahrenheitToTemperature(params.temperatureFh))
                : parseFloat(params.temperatureDc),
            tds: parseFloat(params.tds),
            flow: parseFloat(params.feedFlow * unitsForFlow_m3persec[units.flow]),
            press: parseFloat(params.pressure * unitsForPressure_atm[units.pressure])
          },
          cb_ion_dict: tdsUpdated ? { ...balanceObj, input_mode: inputMode, cb_ph: true }
            : { ...balanceObj, input_mode: inputMode, cb_ph: chargeBalanceIon }, // by Abhishek on 18-April-24 for auto chragrBal. pH send to backend
        };
        setBalanceBtnLoading(true);
        const encData = encrypt_data(obj);
        postFeedInput(encData)
          .then((res) => {
            res.data = decrypt_data(res.data);
            setBalanceBtnLoading(false);
            setPrevParamsChanged(false);
            setDisableBalance(true);
            setIsBalanceClicked(true);
            setDisableOkButton(false);
            const {
              data: { prop_dict, ion_ppm_dict, tot_dict, sat_indices, molal_dict },
            } = res;
            const {
              tot_anion_meql,
              tot_anion_ppmcaco3,
              tot_cation_meql,
              tot_cation_ppmcaco3,
              meql_dict,
              ppm_caco3_dict,
            } = tot_dict;
            const resKeys = Object.keys(ion_ppm_dict);
            const filterdData = [...anionsProp, ...cationsProp];
            const dummyCat = [];
            const dummyAn = [];
            resKeys.filter((key) => {
              const { charge, mass, ionType, Ion, IonCode } = filterdData.find(
                (item) => item.IonCode === key
              );
              if (ionType === 'cations') {
                dummyCat.push({
                  Ion,
                  charge,
                  mass,
                  IonCode,
                  ionType,
                  MgL: Number(ion_ppm_dict[key].toFixed(3)),
                  Meq: Number(meql_dict[key].toFixed(4)),
                  ppmAsCaCO3: Number(ppm_caco3_dict[key].toFixed(2)),
                });
              } else {
                dummyAn.push({
                  Ion,
                  charge,
                  mass,
                  IonCode,
                  ionType,
                  MgL: Number(ion_ppm_dict[key].toFixed(3)),
                  Meq: Number(meql_dict[key].toFixed(4)),
                  ppmAsCaCO3: Number(ppm_caco3_dict[key].toFixed(2)),
                });
              }
            });
            const rows = [
              ...dummyCat,
              {
                Ion: 'Total Cations',
                MgL: getSumValuesForProp(dummyCat, 'MgL'),
                Meq: tot_cation_meql,
                ppmAsCaCO3: tot_cation_ppmcaco3,
              },
              ...dummyAn,
              {
                Ion: 'Total Anions',
                MgL: getSumValuesForProp(dummyAn, 'MgL'),
                Meq: tot_anion_meql,
                ppmAsCaCO3: tot_anion_ppmcaco3,
              },
            ];
            setAnions(dummyAn);
            setCations(dummyCat);
            setAnionsTemp(dummyAn);
            setCationsTemp(dummyCat);
            // sayed idher
            setRowData(rows);
            setTotalCompObj(tot_dict);
            setSaturation({ ...sat_indices });
            setMolalDict({ ...molal_dict });
            setHardness(res.data.hardness);
            setIonicStrength(res.data.ionic_strength);
            localStorage.setItem(
              'tds',
              Number(decimalFormatter(prop_dict.tds, 2))
            );
            setParams({
              ...params,
              malk: Number(decimalFormatter(prop_dict.malk, 3)),
              ph: Number(decimalFormatter(prop_dict.ph, 2)),
              tds: Number(decimalFormatter(prop_dict.tds, 2)),
              feedFlow: Number(decimalFormatter(params.feedFlow, 3)),
              pressure: Number(decimalFormatter(params.pressure, 3)),
              [units.temp === '°F' ? 'temperatureFh' : 'temperatureDc']:
                units.temp === '°F' ?
                  parseFloat(decimalFormatter(prop_dict.temp * 1.8 + 32, 2))
                  : Number(decimalFormatter(prop_dict.temp, 2)),
            });
            tdsUpdated = false;
          })
          .catch(() => {
            setBalanceBtnLoading(false);
            setModalOption({
              ...defaultModalOptions,
              visible: true,
              title: 'Error',
              message: 'Something went wrong',
              yesOrNo: false,
              onNo: () => setModalOption(defaultModalOptions),
              type: 'error'
            });
          });
      }
    }
    jsLogger.info('Feed Balance button clicked');
  };

  const handleConfirm = (isClose = false) => {
    setpdfDdMenuItem([]);  // remove pdf Dropdown
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }

    if (isClose) {
      renderValues({ id: 1 });
      setWaterTypeObj({ waterSource: 1, waterType: 1 });
      setVisibleFeed(false);
    } else {
      renderValues({ id: waterTypeObj.waterType });
      setWaterTypeObj({
        waterSource: waterTypeObj.waterSource,
        waterType: waterTypeObj.waterType,
      });
    }
    setModalOption(defaultModalOptions);
    setIsBalanceClicked(false);
    clearRowData();
    clearParams();
    tdsUpdated = false;
    if (isClose) {
      setVisibleFeed(false);
    }
    jsLogger.info('Feed Clear Value -> Yes button clicked');
  };

  const handleCloseModal = () => {
    if (disableBalance === false || disableOkButton === false || isShowErrorMessage === true) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Do you want close the Feed input page'),
        onYes: () => handleConfirm(true),
        onNo: () => setModalOption(defaultModalOptions)
      });
      // Show red border if user has unsaved changes or if the saved file contains unbalanced composition
      if(disableBalance === true){
        getBorderColor(feedItem.id, 'remove');
      }else{
        getBorderColor(feedItem.id, 'add');
      }
    } else {
      handleConfirm(true);
      jsLogger.info('Feed Cancel -> yes button clicked');
    };
  };

  const clearValues = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      message: translateObject('Do you want clear all the values for the composition'),
      onYes: () => handleConfirm(),
      onNo: () => setModalOption(defaultModalOptions)
    });
  };

  const handleSaveTableData = async () => {
    if (Number(params.ph) < 0 || Number(params.ph) > 14) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('pH should not be between 0.14'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions),
      });
    }
    else if (params.pressure === '' || Number(params.pressure) < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Pressure should not be empty'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions),
      });
    }
    else if (nullParam) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Parameters should not be empty'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions),
      });
    }
    else {
      const setLocal = {
        'grid-data': rowData,
        localParams: params,
        localSaturation: saturation,
        balanceObj,
        inputMode,
        waterTypeObj,
        chargeBalanceIon,
        isShowNF_Feed
      };

      const payload = getDetailGridInfo();
      // finding water source name from id, and id will keep changing in waterTypeObj
      const waterSource_val = waterSource.find(item => Number(item.id) === waterTypeObj.waterSource);
      const { name } = waterSource_val;

      const obj = {
        molal_dict: molalDict,
        sat_indices: saturation,
        ion_ppm_dict: { ...payload },
        prop_dict: {
          malk: params.malk,
          ph: params.ph,
          toc: params.toc,
          temp:
            units.temp === '°F'
              ? fahrenheitToTemperature(params.temperatureFh)
              : params.temperatureDc,
          tds: params.tds,
          flow: params.feedFlow * unitsForFlow_m3persec[units.flow],
          press: params.pressure * unitsForPressure_atm[units.pressure],
          hardness: hardness_val,
          density: Number(saturation.density),
          ionic_str: ionicStrength
        },
        cb_ion_dict: { ...balanceObj, input_mode: inputMode, cb_ph: chargeBalanceIon },
        hardness: hardness_val,
        ionic_strength: ionicStrength,
        water_source: name,
        is_nf_module: isShowNF_Feed,
        isFeedComposition: compositionType.composition,
      };
      localPressure_atm[feedItem.id] = convertUnitValues_pressure(params.pressure, units.pressure, 'atm');
      await saveFormDataInLocalStorage({ record: setLocal, type: 'feed', id: feedItem.id, item: 'form' });
      await saveFormDataInLocalStorage({ record: obj, type: 'feed', id: feedItem.id, item: 'feed-dict' });
      flowData[feedItem.id] = params.feedFlow;
      pressureData[feedItem.id] = params.pressure;
      setVisibleFeed(false);
      // we have added border color red logic due to if user saves without balanceing then we have to feed unitop with red border
      if(getTotal(payload) > 0 || disableBalance === true){
        getBorderColor(feedItem.id, 'remove');
      }else{
        getBorderColor(feedItem.id, 'add');
      }
      tdsUpdated = false;
      if (isShowErrorMessage) {
        localStorage.setItem('globalExitBtn', 'true');
      }
    }
    jsLogger.info('Feed OK button clicked');
  };

  const handleSelectInputMode = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    jsLogger.info(`Feed Parameter Input dropdown value changes to ${e.target.value}`);
    setInputType(e.target.value);
    canCellBeEditable(e.target.value, chargeBalanceIon);
    disabledStripperAndExplorerTab();
  };

  const handleIonChange = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    setBalanceObj({
      cb_cation: 'Na+',
      cb_anion: 'Cl-',
    });
    setInputType(e.target.checked ? '' : 'ph_alk');
    setParams({ ...params, malk: e.target.checked ? '' : 120, ph: e.target.checked ? '' : 7 });
    setChargeBalanceIon(e.target.checked);
    canCellBeEditable(inputMode, e.target.checked);
    jsLogger.info(`Feed form Charge Balance pH ${e.target.checked}`);
    disabledStripperAndExplorerTab();
  };
  const handleNF_feedChanges = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    setWaterTypeObj({
      waterSource: 4, // changed the default water type
      waterType: 1,
    });
    clearRowData();
    clearParams();
    // setInputType(e.target.value);
    // canCellBeEditable(e.target.value, chargeBalanceIon);
    disabledStripperAndExplorerTab();
    setInputType(e.target.checked ? 'ph_alk' : 'ph_alk');
    setParams({ ...params, malk: e.target.checked ? 0 : 120, ph: e.target.checked ? 7 : 7});
    setisShowNF_Feed(e.target.checked);
    // setChargeBalanceIon(e.target.checked);
  };
  const getFeedName = () => {
    let feedName = '';
    const local = localStorage.getItem(feedItem.id);
    if (local) {
      feedName = local;
    } else {
      feedName = `Feed ${Number(get(feedItem, 'id', '').split('_')[1]) + 1}`;
    }
    return feedName;
  };

  return (
    <Modal
      hideBackdrop
      open={visibleFeed}
      onClose={setVisibleFeed}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="feed-modal"
    >
      <Box className=''>
        <Rnd
          default={{
            width: '90%',
            x: ((window.innerWidth / 2) - ((90 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((80 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='43%'
          cancel='.no_drag, .select-dropdown, .feed-header-text,
             .feed-grids, .text-content, .charge-balance-header, .title, .temp-button-group,
              .cb-header-text, .radio-group-container, .feed-cbox, .footer-button-grid'
          className='feed-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='feed-grid-container'>
            <Grid item xs={12} className='feed-header-grid'>
              <div className='feed-header-text no_drag rufusBld S_heading forground-text-primary'>{!isWaterAnalysis?`Feed - ${getFeedName()}`: 'Water Analysis'}</div>
              <div className='feed-close-icon no_drag' style={{ marginRight: '16px', marginTop: '8px', marginBottom: '4px' }}>
                <Tooltip title="Download as csv" placement="top" data-testid="download-csv" arrow>
                  <img
                    src={download_feed}
                    alt="close"
                    onClick={onBtnExport}
                    style={{ width: '24px', padding: '7px', height: '24px' }}
                    className="pointer"
                  />
                </Tooltip>
                <Tooltip title="Close" placement="top" arrow>
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleCloseModal}
                    style={{ width: '14px', padding: '7px' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='feed-content-container'>
              <Grid container style={{ height: '70vh', 'overflow': 'auto', paddingTop: '24px' }} className='feed-content-itemcontainer'>
                <Grid item xs={12} sm={12} md={12} lg={4} className='drag-empty-space'>
                  <div className='feed-content grid-one'>
                    <FeedType
                      units={units}
                      isWaterAnalysis={!isWaterAnalysis}
                      handleChangeWaterComposition={handleChangeWaterComposition}
                      compositionType={compositionType}
                      handleChangeWaterType={handleChangeWaterType}
                      waterTypeObj={waterTypeObj}
                      balanceObj={balanceObj}
                      handleChangeChargeBalance={handleChangeChargeBalance}
                      argoTemplate={argoTemplate}
                      handleChangeArgoTemplate={handleChangeArgoTemplate}
                      balanceBtnLoading={balanceBtnLoading}
                      disableBalance={disableBalance}
                      handleIonChange={handleIonChange}
                      chargeBalanceIon={chargeBalanceIon}
                      isShowNF_Feed={isShowNF_Feed}
                      handleNF_feedChanges={handleNF_feedChanges}
                      rowData={rowData}
                      setRowData={setRowData}
                      setDisableBalance={setDisableBalance}
                      params={params}
                      setParams={setParams}
                      setCations={setCations}
                      setAnions={setAnions}
                      setpdfdropdown={setpdfdropdown}
                      setpdfDdMenuItem={setpdfDdMenuItem}
                      setFileUploadStatus={setFileUploadStatus}
                      fileUploadStatus={fileUploadStatus}
                      pdfDdMenuItem={pdfDdMenuItem}
                      pdfdropdown={pdfdropdown}
                      handleChangePdfRes={handleChangePdfRes}
                      inputMode={inputMode}
                      translateObject={translateObject}
                      dbTransactionDetails={dbTransactionDetails}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4.5}>
                  <div className='feed-content no_drag grid-two'>
                    <div className="feed-grids no_drag">
                      <FeedTable
                        onBtnExport={onBtnExport}
                        refreshGrid={refreshGrid}
                        handleAfterEdit={handleAfterEdit}
                        onGridReady={onGridReady}
                        renderValues={renderValues}
                        waterTypeObj={waterTypeObj}
                        gridApi={gridApi}
                        rowData={rowData}
                        inputMode={inputMode}
                        downloading={downloading}
                        chargeBalanceIon={chargeBalanceIon}
                        columnDefs={properties}
                        isShowNF_Feed={isShowNF_Feed}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={3.5}>
                  <div className='feed-content grid-three'>
                    <Grid container>
                      <Grid item xs={12}>
                        <div className='feed-parameters'>
                          <Parameters
                            handleChangeParams={handleChangeParams}
                            handleSelectInputMode={handleSelectInputMode}
                            setIsShowErrorMessage={setIsShowErrorMessage}
                            params={params}
                            setParams={setParams}
                            inputMode={inputMode}
                            handleBlur={handleBlur}
                            validationDiv={validationDiv}
                            handleChangeUnit={handleChangeUnit}
                            units={units}
                            errors={errors}
                            unitObj={unitObj}
                            chargeBalanceIon={chargeBalanceIon}
                            translateObject={translateObject}
                            isShowNF_Feed={isShowNF_Feed}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className='feed-saturation' style={{ marginTop: '12px' }}>

                          <Saturation saturation={saturation} units={units} translateObject={translateObject} />
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>

              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Divider />
                <Grid item xs={12} className='feed-footer-grid' style={{ padding: 10, display: 'flex', justifyContent: 'end' }}>
                  <div className='no_drag'>
                    <Button
                      variant="contained"
                      className='clearValue_btn Primary_Default_Button btn-auto-width'
                      style={{ marginRight: '20px' }}
                      onClick={clearValues}>
                      {translateObject('Clear Values')}
                    </Button>
                    <LoadingButton
                      loading={balanceBtnLoading}
                      size="small"
                      id="balance_feed"
                      variant="contained"
                      onClick={calculateBalance}
                      disabled={disableBalance}
                      className='Primary_Default_Button btn-auto-width'
                      style={{ marginRight: '20px' }} >
                      {translateObject('Balance')}
                    </LoadingButton>
                    <Button variant="contained" style={{ marginRight: '20px' }} className='Secondary-Default_button btn-auto-width' id="cancel_feed"
                      onClick={handleCloseModal}>{translateObject('Cancel')}</Button>
                    <Button
                      variant="contained"
                      className="Primary_Default_Button btn-auto-width"
                      id="ok_feed"
                      disabled={disableOkButton}
                      style={{ marginRight: '24px' }}
                      onClick={handleSaveTableData}>
                      {translateObject('OK')}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};

export default Feed;